import React from 'react';

import { JobSalary } from '@/graphql/generated';
import { FormattedCurrency } from '@/helpers/i18n';

type Props = {
  salary: JobSalary;
};

export const Salary: React.FC<Props> = ({ salary }) => {
  switch (salary.__typename) {
    case 'Salary': {
      const { amount, currency } = salary;
      return typeof amount === 'number' ? (
        <span data-testid="salary-metadata">
          <FormattedCurrency value={amount} currency={currency} />
        </span>
      ) : null;
    }
    case 'SalaryRange':
    case 'SalaryEstimate': {
      const { minimum, maximum, currency } = salary;
      const isValidRange = typeof minimum === 'number' && typeof maximum === 'number';
      const hasOnlyMaximum = typeof maximum === 'number' && typeof minimum !== 'number';

      if (isValidRange) {
        return (
          <span data-testid="salary-metadata">
            <FormattedCurrency value={minimum} currency={currency} />
            {' – '}
            <FormattedCurrency value={maximum} currency={currency} />
          </span>
        );
      } else if (hasOnlyMaximum) {
        return (
          <span data-testid="salary-metadata">
            <FormattedCurrency value={0} currency={currency} />
            {' – '}
            <FormattedCurrency value={maximum} currency={currency} />
          </span>
        );
      } else {
        return null;
      }
    }
    default:
      return null;
  }
};
